import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Auth.css';

function ForgotPassword() {
  const navigate = useNavigate();

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>CoreWood</h1>
          <h2>Esqueci minha senha</h2>
        </div>

        <div className="auth-message">
          <p>
            Para redefinir sua senha, entre em contato com o administrador
            do sistema. Ele vai gerar um link de redefinição que será enviado
            a você pelo canal de comunicação interno.
          </p>
          <p className="auth-message-secondary">
            O link expira em 1 hora após ser gerado.
          </p>
        </div>

        <button
          onClick={() => navigate('/login')}
          className="auth-button"
        >
          Voltar ao login
        </button>
      </div>
    </div>
  );
}

export default ForgotPassword;
